import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the harmless "ResizeObserver loop completed with undelivered notifications"
// dev-overlay error which can intermittently block clicks on pages using Radix Select.
const _resizeObsMsg = "ResizeObserver loop";
window.addEventListener(
  "error",
  (e) => {
    if (e?.message?.includes(_resizeObsMsg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

// Register service worker (PWA) — only in production-like contexts, not the dev preview iframe.
if ("serviceWorker" in navigator && window.self === window.top) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[PWA] SW registration failed:", err));
  });
}

// Capture the install prompt for later use (custom "Install" button in the app).
window.deferredPwaPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.deferredPwaPrompt = e;
  window.dispatchEvent(new CustomEvent("pwa-installable"));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
